import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PessoaTipoBadgeModule } from '../../tipo/components/badge';
import { ClientePipeSharedModule } from '../pipes';
import { ClienteAnaliseFinanceiraConcluirModule } from '../analise-financeira/concluir-modal';
import { ClienteAnaliseFinanceiraRevisarModule } from '../analise-financeira/revisar-modal';
import { ClienteListComponent } from './cliente-list.component';
import { ClienteCarteiraCongelarModule } from '../../../cliente-carteira/congelar';
import { ClienteCarteiraPreBaixarModule } from '../../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModule } from '../../../cliente-carteira/baixar';
import { NegocioFormInsertModalModule } from '../../../crm/negocio/form-insert/modal/negocio-form-insert-modal.module';
// import { NegocioOportunidadeFormModule } from "../../../crm/negocio/oportunidade/form/negocio-oportunidade-form.module";

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoBadgeModule,
        ClientePipeSharedModule,
        ClienteAnaliseFinanceiraConcluirModule,
        ClienteAnaliseFinanceiraRevisarModule,
        ClienteCarteiraCongelarModule,
        ClienteCarteiraPreBaixarModule,
        ClienteCarteiraBaixarModule,
        NegocioFormInsertModalModule,
        // NegocioOportunidadeFormModule
    ],
    declarations: [
        ClienteListComponent
    ],
    exports: [
        ClienteListComponent
    ]
})
export class ClienteListModule { }
